import { Divider, Grid, IconButton, Tooltip } from "@material-ui/core";
import { Apps, CloseRounded, Delete, Star, StarOutline, } from "@material-ui/icons";
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { get_ESD_indexedDB_factory } from "../js/function";
import { IndexedDBClass } from "../js/indexedDB";
import { MostUsedPages } from "../_AAA/indexedDB_types";
import { ResultObj, checkSign, esd_storage, getPermision } from "../js/Domain";
import { Location } from "react-router-breadcrumbs-hoc";
import { ReactBasicTable2 } from "../_AAA/components/ReactTeable2";
import { ReactIconBtn } from "../_AAA/components/ReactButton";
import { ConfirmDialogPropsScroll, ConfirmDialogPropsSize, HandleEvent, PageState } from "../js/types";
import { ConfirmDialogTS, SnackbarDialogTS } from "../_AAA/components/ReactDialogTS";
import { useSnackbar } from "notistack";
import { MuiAlert } from "../_AAA/components/ReactAlert";
import { NoResults } from "../_AAA/components/ReactError";
/** 最常訪問頁面 IDB 資料存取格式 */
export interface IDBMostUsedPagesDataType {
    page: string,
    dateArr: Date[],
    favorite: string,
}

/** 紀錄最愛收藏頁按鈕 */
export function RecordMostUsedPageButton() {
    const history = useHistory();
    const context = useContext(MyFavoritePageContext)

    /** 註冊換頁觸發事件 */
    const recordListen = useCallback(async (newLocation: Location, action: string) => {
        if (context) {
            if (action === 'PUSH') {
                let IDBData = await context.searchIDBMostUsedPagesData(),
                    foundIndex = IDBData.findIndex(data => data.page === window.location.pathname)

                // 若已存在 更新 times 與 date 狀態
                if (foundIndex !== -1) {
                    IDBData[foundIndex].dateArr.push(new Date())
                }
                // 若不存在 則新增
                else {
                    IDBData = IDBData.concat({
                        page: window.location.pathname,
                        favorite: 'N',
                        dateArr: [(new Date())]
                    })
                }
                // 設定目前頁面
                context.setIDBMostUsedPagesData(IDBData)
            }
        }
    }, []);

    /** 加入我的收藏 */
    async function handleAddFavorite() {
        if (context) {
            let IDBData = [...context.IDBMostUsedPagesData],
                foundIndex = IDBData.findIndex(data => data.page === window.location.pathname)

            // 若已存在 更新 favorite 狀態
            if (foundIndex !== -1) {
                IDBData[foundIndex].favorite = IDBData[foundIndex].favorite !== 'Y' ? 'Y' : 'N'
            }
            // 若不存在 則新增
            else {
                IDBData = IDBData.concat({
                    page: window.location.pathname,
                    favorite: 'Y',
                    dateArr: [new Date()]
                })
            }
            // 設定目前頁面
            context.setIDBMostUsedPagesData(IDBData)
        }
    }

    useEffect(() => {
        const unlisten = history.listen(recordListen);
        return () => {
            unlisten();
        };
    }, [history, recordListen])

    return <React.Fragment>
        {context
            ? <Tooltip
                placement="bottom"
                title={"加入至我的收藏"}
                arrow={true}
                data-aria="simple">
                <IconButton
                    className="tourBtn"
                    size="small" color="primary"
                    onClick={() => { handleAddFavorite() }}
                >
                    {context.IDBMostUsedPagesData.some(data => data.page === window.location.pathname) &&
                        context.IDBMostUsedPagesData.find(data => data.page === window.location.pathname)?.favorite === 'Y'
                        ? <Star />
                        : <StarOutline />}
                </IconButton>
            </Tooltip>
            : null
        }
    </React.Fragment>
}

/** 我的收藏視窗 */
export function ModalMyFavoriteInner() {
    const history = useHistory()
    const context = useContext(MyFavoritePageContext)
    const [dataArr, setDataArr] = useState<{
        /** 平台名稱 */
        platFormName: string,
        /** 頁面組別名稱 */
        groupName: string,
        /** 頁面名稱 */
        pagename: string,
        /** 頁面代碼 */
        code: string,
        /** 可到達頁面路徑 */
        path: string,
        /** 紀錄於IDB頁面路徑 */
        recordPath: string,
        /** 頁面id */
        pg_id: string,
        /** 是否為 我的收藏 */
        isFavorite: boolean,
    }[]>([])

    const [state, setState] = useState<PageState>({
        isLoaded: false,
        modalOpen: false,
        modal: null,
        dialogInfo: null,
        openDialog: false,
    })
    const { closeSnackbar, enqueueSnackbar } = useSnackbar()

    // #region function
    /** 初始整理資料 */
    async function init() {
        if (context) {
            const
                /** 查詢 IDB 資料 */
                AllIDBData =
                    // 查詢 IDB 我的收藏資料
                    context.IDBMostUsedPagesData.filter(ele => ele.favorite === 'Y').concat(
                        // 查詢 IDB 最常造訪資料
                        context.IDBMostUsedPagesData
                            // 過濾已是收藏
                            .filter(ele => ele.favorite !== 'Y')
                            // 造放次數多至少排序
                            .sort(
                                (a, b) => b.dateArr.length - a.dateArr.length
                            )
                            //取前三筆
                            .slice(0, 3)
                    ),

                /** 查詢 所有權限 */
                resPermision = await checkSign().then(async (loginRes) => {
                    if (loginRes.success) {
                        return await getPermision(loginRes.data.path);
                    } else return null
                })

            /** 整理好的頁面 Array */
            let favoritePageArr: typeof dataArr = []

            //檢查權限與其首頁
            if (!!resPermision && AllIDBData.length) {
                // 平台
                for (let platFormIndex in resPermision.items) {
                    // sideBar/nav
                    /** 平台物件 */
                    const platFormItem = resPermision.items[platFormIndex]
                    for (let childIndex in resPermision.items[platFormIndex].children) {
                        // 平台內 側邊欄陣列
                        if (resPermision.items[platFormIndex].children[childIndex].name === "sidebar") {
                            // 檢查
                            for (let sideItemIndex in resPermision.items[platFormIndex].children[childIndex].children) {
                                /** 頁面組別物件 */
                                const sideItem = resPermision.items[platFormIndex].children[childIndex].children[sideItemIndex]
                                // 判斷非控制台
                                if (sideItem.code !== "Index") {
                                    for (let firstPageItemIndex in resPermision.items[platFormIndex].children[childIndex].children[sideItemIndex].children) {
                                        /** first 頁面物件 */
                                        const firstPageItem = resPermision.items[platFormIndex].children[childIndex].children[sideItemIndex].children[firstPageItemIndex]
                                        /** second 頁的頁面物件 */
                                        let secondPageItem: typeof firstPageItem | undefined = undefined
                                        AllIDBData.forEach(favItem => {
                                            // 查找是否為 Second 頁
                                            secondPageItem = firstPageItem.children.find(pcItem => pcItem.path === favItem.page)
                                            if (
                                                // 查找是否相符合
                                                favItem.page === firstPageItem.path || secondPageItem
                                            ) {

                                                favoritePageArr.push({
                                                    platFormName: platFormItem.name + '--' + resPermision.nav?.children.find(navItem => navItem.code === platFormItem.name)?.name + '',
                                                    groupName: sideItem.name,
                                                    pagename: firstPageItem.name + (secondPageItem ? '/' + secondPageItem.name : ''),
                                                    code: firstPageItem.code,
                                                    path: firstPageItem.path,
                                                    recordPath: favItem.page,
                                                    pg_id: firstPageItem.pg_id + '',
                                                    isFavorite: favItem.favorite === 'Y'
                                                })
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
            setDataArr(favoritePageArr)
        }
    }

    /** API 錯誤 */
    const responseMessage = async (res: ResultObj & { persist?: boolean }) => {
        setState((prevState) => ({
            ...prevState,
            isLoaded: true,
        }))
        enqueueSnackbar(res.message, {
            variant: res.success ? "success" : "warning", // 顏色
            persist: res.persist ? res.persist : !res.success, // 是否要一直存在畫面
            action: key => ( // 錯誤通知 + 查看詳細
                < IconButton onClick={() => { closeSnackbar(key) }}>
                    <CloseRounded style={{ color: "#fff" }} />
                </IconButton >
            )
        });
    }
    // #endregion 

    // #region click function
    /** 移除我的收藏 modal click 
        * @param e event
        * @param item 刪除項目資料
        */
    function delModalClick(e: HandleEvent, item: typeof dataArr[number]) {
        e.stopPropagation()
        setState(prev => ({
            ...prev,
            modalOpen: true,
            modal: {
                id: 'delMyFavoriteModal',
                modaltitle: '刪除',
                messages: <React.Fragment>
                    確定要移除我的收藏<br />
                    頁面名稱:
                    <span style={{ color: "#3f51b5" }}>{item.pagename.split('/')[1]
                        ? item.pagename.split('/')[1]
                        : item.pagename}</span>
                </React.Fragment>,
                modalAction: () => delModalConfirm(item),
                scroll: ConfirmDialogPropsScroll.BODY,
                size: ConfirmDialogPropsSize.XS,
            }
        }))
    }

    /** 移除我的收藏 modal confirm */
    async function delModalConfirm(item: typeof dataArr[number]) {
        if (context) {
            let IDBData = [...context.IDBMostUsedPagesData],
                foundIndex = IDBData.findIndex(data => data.page === item.recordPath)

            // 若已存在 更新 favorite 狀態
            if (foundIndex !== -1) {
                IDBData[foundIndex].favorite = 'N'
            }
            // 若不存在
            else {
                responseMessage({ message: '刪除失敗 ! 查無項目', data: { '查詢代碼': '查詢代碼:' + foundIndex }, success: false })
                return
            }
            // 設定目前頁面
            context.setIDBMostUsedPagesData(IDBData)
            setDataArr(prev => (prev.filter(ele => ele.recordPath !== item.recordPath)))
            setState(prev => ({
                ...prev,
                modalOpen: false,
                modal: null
            }))
            responseMessage({ message: '我的收藏移除成功 !', data: null, success: true })
        }
    }

    /** 加入我的收藏 */
    async function handleAddFavorite(e: HandleEvent, item: typeof dataArr[number]) {
        e.stopPropagation()
        if (context) {
            let IDBData = [...context.IDBMostUsedPagesData],
                foundIndex = IDBData.findIndex(data => data.page === item.recordPath)

            // 若已存在 更新 favorite 狀態
            if (foundIndex !== -1) {
                IDBData[foundIndex].favorite = 'Y'
                setDataArr(prev => {
                    let newArr = [...prev],
                        foundInd = prev.findIndex(data => data.recordPath === item.recordPath)
                    if (foundInd !== -1) {
                        newArr[foundInd].isFavorite = true
                    }
                    return newArr
                })
            }
            // 若不存在
            else {
                responseMessage({ message: '刪除失敗 ! 查無項目', data: { '查詢代碼': '查詢代碼:' + foundIndex }, success: false })
                return
            }
            // 設定目前頁面
            context.setIDBMostUsedPagesData(IDBData)
        }
    }

    /** 點擊至 second頁 
    * @param item 欲編輯項目資料
    */
    async function handlePageClick(item: typeof dataArr[number]) {
        if (item.path) {
            // 轉址設定
            sessionStorage.home_page = item.platFormName.split('--')[0];
            sessionStorage.home_page_name = item.platFormName.split('--')[1];
            sessionStorage.nowPage = 1;
            history.push(item.path)
            window.location.reload();
        } else responseMessage({ message: 'ESD location Error', data: { location: item.path, item: item }, success: false })
    }
    // #endregion 

    useEffect(() => {
        init()
    }, [])

    return <React.Fragment>
        <MuiAlert severity="warning" style={{ marging: "0 6px" }}
            text="若為編輯頁，將先轉至選單頁面。" />

        {/* 我的收藏 TABLE */}
        <Grid item lg={12} md={12} xs={12} style={{ marginBottom: "1rem" }}>我的收藏</Grid>
        {dataArr.filter(pageItem => !!pageItem.isFavorite).length
            ? <ReactBasicTable2<typeof dataArr[number] & { [key: string]: any }>
                aria="simple"
                hasRowsPerPage={false}
                hasHover={true}
                tableHead={[
                    { name: '平台', key: 'platFormNameZH' },
                    { name: '群組', key: 'groupName' },
                    { name: '頁面名稱', key: 'pagenameZH' },
                    { name: '操作', key: 'tool' },
                ]}
                data={dataArr.filter(pageItem => !!pageItem.isFavorite).map((pageItem, pageIndex) => ({
                    key: pageItem.recordPath,
                    data: {
                        ...pageItem,
                        platFormNameZH: pageItem.platFormName.split('--')[1],
                        pagenameZH: pageItem.pagename.split('/')[1]
                            ? pageItem.pagename.split('/')[1]
                            : pageItem.pagename,
                        tool: <ReactIconBtn
                            className='btnDelete'
                            tiptitle='移除我的收藏'
                            ariaLabel="delete group list"
                            color="primary"
                            click={(e: HandleEvent) => { delModalClick(e, pageItem) }}
                            icon={<Delete />} />

                    }
                }))}
                trClick={handlePageClick}
            />
            : <NoResults title='尚未設定收藏頁面' />}
        <Divider variant="middle" style={{ margin: "1.5rem 0rem" }} />

        {/* 最常造訪 TABLE */}
        <Grid item lg={12} md={12} xs={12} style={{ marginBottom: "1rem" }}>最常造訪</Grid>
        {dataArr.filter(pageItem => !pageItem.isFavorite).length
            ? <ReactBasicTable2<typeof dataArr[number] & { [key: string]: any }>
                aria="simple"
                hasRowsPerPage={false}
                hasHover={true}
                tableHead={[
                    { name: '平台', key: 'platFormNameZH' },
                    { name: '群組', key: 'groupName' },
                    { name: '頁面名稱', key: 'pagenameZH' },
                    { name: '操作', key: 'tool' },
                ]}
                data={dataArr.filter(pageItem => !pageItem.isFavorite).map((pageItem, pageIndex) => ({
                    key: pageItem.recordPath,
                    data: {
                        ...pageItem,
                        platFormNameZH: pageItem.platFormName.split('--')[1],
                        pagenameZH: pageItem.pagename.split('/')[1]
                            ? pageItem.pagename.split('/')[1]
                            : pageItem.pagename,
                        tool: <ReactIconBtn
                            className='btnDelete'
                            tiptitle='新增至我的收藏'
                            ariaLabel="add group list"
                            color="primary"
                            click={(e: HandleEvent) => { handleAddFavorite(e, pageItem) }}
                            icon={<StarOutline />} />

                    }
                }))}
                trClick={handlePageClick}
            />
            : <NoResults title='尚未有最常造訪頁面資料' />}

        <SnackbarDialogTS
            dialogInfo={state.dialogInfo}
            openDialog={state.openDialog}
            maxWidth="xs"
            closeClick={() => setState({ ...state, openDialog: false })}
            color="primary"
        />
        <ConfirmDialogTS
            modal={state.modal}
            modalOpen={state.modalOpen}
            closeClick={() => setState({ ...state, modalOpen: false, modal: null })}
        />

    </React.Fragment>
}

/** 我的收藏視窗 icon 點擊 */
export function MyFavoriteIcon() {
    const [state, setState] = useState<PageState>({
        isLoaded: false,
        modalOpen: false,
        modal: null,
        dialogInfo: null,
        openDialog: false,
    })
    /** 點擊我的最愛 */
    const favoriteHandleClick = () => {
        setState(prev => ({
            ...prev,
            modalOpen: true,
            modal: {
                modaltitle: "我的收藏",
                messages:
                    <ModalMyFavoriteInner />,
                size: ConfirmDialogPropsSize.XS, // modal 大小
                scroll: ConfirmDialogPropsScroll.BODY,
                modalAction: () => setState(prev => ({ ...prev, modal: null, modalOpen: false })),
            },
        }));
    }
    return <React.Fragment>
        <ReactIconBtn
            // NOTE icon圖示仍待討論
            // icon={<Stars style={{ fill: '#fff' }} />}
            icon={<Apps style={{ fill: '#fff' }} />}
            click={favoriteHandleClick}
            tiptitle='開啟收藏列'

        />
        <ConfirmDialogTS modal={state.modal} modalOpen={state.modalOpen} closeClick={() => setState(prev => ({ ...prev, modal: null, modalOpen: false }))} />
    </React.Fragment>
}

// #region 最常訪問頁面 Context
/** 最常訪問頁面 Context type */
type myFavoritePageContextType = {
    /** 最常訪問頁面 IDB 資料 */
    IDBMostUsedPagesData: IDBMostUsedPagesDataType[],
    /** 查詢 最常訪問頁面 IDB 資料 */
    searchIDBMostUsedPagesData(): Promise<IDBMostUsedPagesDataType[]>,
    /** 儲存 最常訪問頁面 IDB 資料 */
    setIDBMostUsedPagesData: React.Dispatch<React.SetStateAction<IDBMostUsedPagesDataType[]>>
}

/** 最常訪問頁面 Context */
const MyFavoritePageContext = createContext<myFavoritePageContextType | undefined>(undefined)

/** 最常訪問頁面 Context Provider */
export const MyFavoritePageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    /** 公司代碼 */
    let company_code: string | null = sessionStorage.getItem("company_code");
    // 最常訪問與我的收藏頁面資料
    const [IDBMostUsedPagesData, setIDBMostUsedPagesData] = useState<IDBMostUsedPagesDataType[]>([])
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [idb, setIdb] = useState<IndexedDBClass | null>(null)

    /** 查詢 IDB 頁面資料 */
    async function searchIDBMostUsedPagesData() {
        return await get_ESD_indexedDB_factory().then(
            async (idb: IndexedDBClass | null) => {
                /** 查 order IDB 暫存內容 */
                let IDBData: IDBMostUsedPagesDataType[] =
                    idb !== null
                        ? await idb.search<MostUsedPages<IDBMostUsedPagesDataType[]>>(
                            "MostUsedPages",
                            [
                                company_code ?? '',
                                esd_storage.user_id,
                            ]
                        ).then((res: ResultObj<MostUsedPages<IDBMostUsedPagesDataType[]>>) => {
                            if (res.success && res.data) {

                                return res.data.data;
                            } else return [];
                        })
                        : [];
                setIdb(idb)
                setIDBMostUsedPagesData(IDBData)
                setIsLoaded(true)
                return IDBData
            })
    }

    /** 設定 IDB 頁面資料 */
    function setIDB(Data: IDBMostUsedPagesDataType[]) {
        // 設定目前頁面
        if (idb !== null) {
            idb.update("MostUsedPages", {
                company_code: company_code ?? '',
                user_id: esd_storage.user_id,
                data: Data
            })
        };
    }

    // #region useEffect
    useEffect(() => {
        searchIDBMostUsedPagesData()
    }, [])

    useEffect(() => {
        if (isLoaded) {
            setIDB(IDBMostUsedPagesData)
        }
    }, [IDBMostUsedPagesData])
    // #endregion

    return (
        <MyFavoritePageContext.Provider value={{ IDBMostUsedPagesData, searchIDBMostUsedPagesData, setIDBMostUsedPagesData }}>
            {children}
        </MyFavoritePageContext.Provider>
    )
}
// #endregion
